export default {
    locale: "en-US",
    language: "English",
    menu: {
        i18n: "Internationalization"
    },
    page: {
        content: {
            MoreAndMore: "More", //更多
            loginTip: "You are not logged in, please log in first", //您尚未登录 请先登录
            passValid: "Confirm password and new password should be the same!", // 确认密码和新密码应保持一致！
            passValid1: "Old and new passwords cannot be duplicated！", //旧密码和新密码不能重复！
            blockNoData: "No further announcements yet", //暂无更多公告
            supplierPortal: "Home", //首页
            projectCode: "Project number", //项目编号
            publishTime: "Release time", //发布时间
            xunjiajiezhiTime: "Inquiry closing time", //询价截止时间
            ApplicationTime: "Application deadline", // 报名截止时间
            labelMenu1: "Bid Evaluation Results", //评标结果
            labelMenu2: "Abortive Tender Announcements", //流标公告
            labelMenu3: "Addendum Notices", //补遗公告
            labelMenu4: "Invitation announcement", //邀请公告
            labelMenu5: "Notification of Award", //中标通知
            labelMenu6: "Purchase by bidding", //招标采购
            labelMenu7: "request for quotation", //询价采购
            labelMenu8: "Competitive negotiation", //竞争谈判
            labelMenu9: "Selective auction", // 邀请竞价
            labelMenu10: "Open quotation", //公开询价
            labelMenu11: "Open auction", //公开竞价
            labelMenu12: "Public auction", // 公开拍卖
            projectNamePlaceholder: "Please enter a project name", //请输入项目名称
            search: "search", //搜索
            allClassify: "All categories", //全部分类
            menu1: "Home", //首页
            menu2: "Centralized purchasing", //集中采购
            menu3: "Regional co-mining", //区域联采
            menu4: "Supplier register", //供应商注册
            menu5: "Supply chain finance", //供应链金融
            menu6: "Business collaboration", //业务协同
            menu7: "Station message", // 站内信
            menu8: "Supplier information change", //供应商信息变更
            menu9: "Application for cooperation intention", //合作意向申请
            menu10: "Contact Us",
            menu11: "Cloud rental APP",
            menu12: "Retrieve password",
            Hello: "Hello", //您好
            welcomeToBack: "Hi, welcome back", //Hi,欢迎回来
            denglu: "Login",
            zhuce: "Registration",
            loginText: "Login to Supplier portal", //登录供应商门户
            Exit: "Logout", //退出
            improveInfo: "Improve information",
            changeInfo: "Modify information",
            viewReasons: "View reasons",
            withdrawApplication: "withdraw",
            supplierLogin: "Supplier Login", //供应商登录
            pleaseLogin: "Please log in", //请登录
            Announcements: "Notice", //通知公告
            purchase: "purchase", //采购
            inviteNotice: "Invitation announcement", // 邀请公告
            noticeName: "Announcement name", // 公告名称
            xunjiaName: "Name of inquiry", //询价名称
            wasteNotice: "Announcement on disposal of waste materials", // 废旧物资处置公告
            lianhecaigou: "Joint Procurement Zone Announcement", // 废旧物资处置公告
            category: "Classification", // 类别
            projectName: "Project name", //项目名称
            searchPlaceholder: "Search item announcement", //搜索 项目公告
            packageNum: "Package number", //包件数量
            fromEndTime: "End of distance", //距离结束
            viewDetail: "View details", //查看详情
            downLoad: "Download", //下载
            to: "to", //至
            startTime: "Start time", //开始时间
            endTime: "End time", //结束时间
            joinStatus: "Participating state", //参与状态
            title: "Title", //标题
            titlePlaceholder: "Please enter the title fuzzy query", //请输入标题模糊查询
            serialNo: "No.", //序号
            publishUnit: "Publishing unit", //发布单位
            signUpEndTime: "Registration ends the remaining time", //报名结束剩余时间
            day: "day", //天
            hour: "hour", //时
            minute: "minute", //分
            second: "second", //秒
            immediatelySignUp: "Register Now (Suppliers only)", //立即报名（仅供应商可报名）
            participated: "Already participated", //已参与
            toMyProject: "Enter the project", //进入项目
            notice: "announcement", //公告
            noticeTitle: "Announcement title", //公告标题
            noticeContent: "Announcement content", //公告内容
            contractInfo: "Contact information", //联系信息
            fileList: "Attachments", //附件列表
            supplierBiddingProcess: "Supplier bidding operation process", //供应商投标操作流程
            pleaseClickView: "Please click to Check", //请点击查看
            packageDesc: "Package description", //包件说明
            materialInfo: "Material information", //物资信息
            relatedNoticeList: "List of related announcements", //相关公告列表
            purchaseMoney: "Purchase amount", //采购金额
            thousandYuan: "Ten thousand yuan", //万元
            camulativePurchaseItems: "Cumulative purchase items", //累计采购项目
            inquiryProjectNum: "Quantity of requested items", //询价项目数量
            biddingProjectNum: "Number of competing projects", //竞谈项目数量
            unitStillPurchase: "The unit is still purchasing", //该单位还在采购
            fileName: "Attachment Name", //附件名称
            fileDesc: "Attachment description", //附件说明
            fileTime: "Upload time", // 上传时间
            fileSize: "Attachment size", //附件大小
            upload: "Download", //下载(英文)
            operation: "Operation", //操作
            equipmentName: "Equipment and materials name", //设备物资名称
            equipmentDesc: "Equipment and materials description", //设备物资说明
            num: "Quantity", //数量
            unit: "Unit", //单位
            type: "Type", //类型
            link: "Step", //环节
            other: "Others", //其他
            aboutUs: "About us", //关于我们
            introPlatform: "Platform introduction", //平台简介
            contactUs: "Contact us", //联系我们
            contactUsPostcode: "postcode", // 邮编
            contactUsPhone: "telephone", //电话
            contactUsConsultTime: "Consultation time", //咨询时间
            exceptStatutoryHolidays: "Except statutory holidays", // 法定节假日除外
            relevantPoliciesAndRegulations: "Relevant policies and norms", //相关政策与规范
            purchaser: "Procuring agent", //采购方
            operationGuide: "Operation instruction", //操作指引
            videoTutorial: "Video tutorial", //视频教程
            supplier: "supplier", //供应商
            supplierName: "Supplier name", //供应商名称
            netInformation: "Instructions for network access", //入网须知
            commonProblem: "Common problem", //常见问题
            purchaseCommonProblem: "Frequently asked questions of the purchaser", //采购方常见问题
            supplierCommonProblem: "Supplier FAQ", //供应商常见问题
            serviceCenter: "Service center", //服务中心
            onlineCounsel: "Online consultation", //在线咨询
            afterSalesService: "After-sales service", //售后服务
            feedback: "feedback", //意见反馈
            fileTemplateDownload: "File template Download", //文件模板下载
            supplyChainFinanceCenter: "Supply chain finance center", //供应链金融中心
            officialWeChat: "official wechat", //官方微信
            navigation: "Column navigation", //栏目导航
            source: "Source", //来源
            add: "add", //新增
            author: "author", //作者
            publishDate: "Release date", //发布日期
            all: "All", //全部
            prev: "< Prev", //上一页
            next: "Next >", //下一页
            To: "Go to", //到第
            page: "page", //页
            article: " article", //条
            total: "Total", //共
            eachPage: "/p", //每页
            sure: "Confirm", //确定
            noRelatedData: "No relevant data is available", //暂无相关数据
            supplierOperationManual: "Supplier operating manual", //供应商操作手册
            operationManual: "Operation manual", //操作手册
            supplierOperationGuide: "Supplier operation guide ", //供应商操作指南
            noData: "No data", //暂无数据
            question: "FAQ", //业务流程及常见问题
            purchaseType: "Procurement method", //采购方式
            xunjiaType: "Inquiry method", //询价方式
            materialClassify: "Classification of materials", //物资分类
            multiSelect: "Multiple choice", //多选
            cancel: "Cancel", //取消
            onlySupplierLogin: "Vendor login only optional", //仅供应商登录可选
            publicBidding: "Open tendering", //公开招标
            InvitationToTender: 'Invitation to tender',
            publicInquiry: "Open quotation", //公开询价
            publicOutcry: "Open auction", //公开竞价
            otherProcurement: "Other procurement methods", //其他采购
            openSingleSource: "Open single source procurement", //公开单一来源
            openofflineBidding: "offline open tendering", //线下公开招标
            offlinePublicInquiry: "offline open quotation", //线下公开询价
            disposalofWasteMaterials: "Waste materials", //废旧物资
            openCollaboration: "Open cooperative negotiation", //公开合作谈判
            wasteMaterials: "Disposal of waste materials", //废旧物资处置
            publicAuction: "Public auction", //公开拍卖
            inquiry: "Invitation for inquiry", //邀请询价
            direct: "Direct Procurement",//直接采购
            inviteBidd: "Selective auction", //邀请竞价
            agreementType: "(Agreement type) Open bidding", //协议类公开
            invitationType: "Invitation to tender (agreement type)", // 协议类邀请
            competitiveNegotiation: "Inviting Competitive Negotiations", //邀请竞争性谈判
            invitationTender: "Selective tendering", //邀请招标
            nearly3Days: "Last 3 Days", //近3天
            nearly7Days: "Last week", //近一周
            nearly30Days: "Last month", //近一个月
            invite: "Invite", //邀请
            open: "publicity", //公开
            pleaseEnterTheTitle: "Please enter the title", //请输入标题
            // category: "category", //类别
            totalResult: "Total result", //全部结果
            openCompetitiveNegotiations: "Open competitive negotiations", //公开性竞争谈判
            openCompetitiveNegotiation: "Open competitive negotiation", //公开竞争性谈判
            procurementAnnouncement: "Procurement announcement", //采购公告
            laowucaiLink: "Supplier Portal (Old Version)", //供应商门户（旧版）
            laowucaiLinkMsg: "Note: Click here to access the legacy supplier portal and complete ongoing tender operations.", //供应商门户（旧版）
            invitationAnnouncement: "Invitation announcement", //邀请公告
            applicationDeadline: "Application deadline", //报名截止时间
            serviceAnnouncement: "Service announcement", //业务公告
            resourceSharing: "Resource sharing", //资源共享
            qualityService: "Quality service", //优质服务
            legalCompliance: "Legal compliance", //合法合规
            reduceCostsAndincrease: "Reduce costs and increase efficiency", //降本增效
            managementPromotion: "Management promotion", //管理提高
            businessCoordinationToBeDone: "Business coordination to be done", //业务协同待办
            pleaseSelectStatusTip: "Please select status query", //请选择状态查询
            pleaseSelectPurchaseTypeTip: "Please select the purchasing method", //请选择采购方式查询
            agreementTypeOpenBidding: "(Agreement type) Open tendering", //(协议类)公开招标
            invitationToTenderagreement: "(Agreement type) Selective tendering", //(协议类)邀请招标
            status: "status", //状态
            pleaseSelectStatus: "Please select status query", //请选择状态查询
            inThePublicity: "In the publicity", //公示中
            alreadyEnded: "Closed ", //已结束
            preview: "Preview", //预览
            Copyright1: "Copyright © 2018 Zhongjiao E-commerce All rights reserved.", //Copyright © 2018 中交电商 All rights reserved.
            divider: "Right of final interpretation:", //最终解释权
            statement1: "Fujian ICP for 2022005227-2 in e-commerce" //闽ICP备2022005227号-2 中交电商
        },
        sup: {
            title: "Instructions", // 供应商操作指南
            content1: "Materials Purchasing Management Information System of CCCC", //中国交建电子采购平台 —— 供应商门户（
            content2: "is the only legitimate website for trade suppliers and CCCC. CCCC keeps a positive cooperation relationship with suppliers on the basis of 'Heart-to-heart business, win-win cooperation'.",
            //）是供应商加入中国交通建设股份有限公司（以下简称“中国交建”）供应商网络的唯一合法的电子商务网站。中国交建按照“互利共赢、诚信合作”的原则，与供应商建立积极的合作关系。
            content3: "CCCC implements access management on suppliers, and those suppliers that have access are qualified to participate in the online bidding and quotation of CCCC and its affiliated enterprises. All suppliers who intend to participate in the procurement business of CCCC should carefully read the network entry instructions and registration guidelines and choose",
            //中国交建对供应商实行准入管理，经准入的供应商具备参与中国交建及所属企业的线上投标和报价资格。凡有意参与中国交建采购业务的供应商均须认真阅读入网须知及注册指南，选择
            content4: " registration (the recommended unit is the preliminary examination unit of the supplier information), after the examination and approval of the network.", //注册（推荐单位为供应商信息的初审单位），经审核通过后入网。
            content5: "To ensure system stability and compatibility, use this command", //请为保证系统的稳定兼容性，请使用
            content6: " or above version of Internet Explorer (while selecting compatibility mode) for best results. For the setting method, see:", //或以上版本的IE浏览器（同时选择兼容模式），以获得最佳效果。设置方法参见：
            contentStrong: "Recommended By", // 推荐单位
            questions: "Frequently Asked Questions", //常见问题解答
            explain: "Other instructions are as follows:", //其他说明如下：
            explain1: "1. Notice of Registration", // 供应商入网须知
            explain2: "2. Registration Instructions", // 注册流程
            explain3: "3. Frequently Asked Questions", //常见问题解答
            explain4: "2. Operation manual",
            explain5: "5. How to retrieve password", //如何找回密码
            explain6: "6. Supplier online bidding important tips and operation process", //供应商在线投标重要提示及操作流程
            supNetInformation: "Notice of Registration", // 供应商入网须知
            netInformation1: "1.This website is the only official supplier access of China communications construction Co.ltd('CCCC').CCCC keeps a positive cooperation relationship with suppliers on the basis of 'Heart-to-heart business, win-win cooperation'.",
            // 中国交通建设股份有限公司设备物资采购管理信息平台是供应商加入中国交通建设股份有限公司（以下简称“中国交建”）供应商网络的唯一合法网站。中国交建按照“互利共赢、诚信合作”的原则，与供应商建立积极的合作关系。
            netInformation2: "2.There is no any other cost to be beared by suppliers for this registration, and CCCC will never charge to suppliers by means of annual verification,membership,performance assessment, etc. Suppliers must ensure all the registration information shall be real,accurate and updated.",
            //中国交通建设股份有限公司对申请入网的供应商不收取任何费用，不颁发相关证书，也不以年审、会员制、业绩考核等名义向供应商收取费用。供应商填写入网信息必须真实、准确并及时更新。
            netInformation3: "3. In case of system upgrade, the platform operator has the right to extend the end time of bidding and the end time of sale.", //如遇系统升级，平台运营方有权延长招标结束时间、售标结束时间。
            faqName: "Supplier online bidding important tips and operation process", //供应商在线投标重要提示及操作流程
            createUserName: "China Communications Construction Corporation Limited", //中国交通建设股份有限公司
            releaseMechanism: "Publish By:", //发布机构：
            releaseTime: "Release time:", //发布时间：
            titleContent: "In order to ensure the smooth progress of the bidding activities, please read the following contents carefully:", //为保障招标活动的顺利进行，请投标供应商认真阅读以下内容：
            titleContent1: "1. Avoid bidding peak hours: peak hours (8:00-18:00), especially the day before the bid deadline.",
            //一、避开投标高峰时间：高峰时间（8:00—18:00），特别是投标截止日前一天。
            titleContent2: "2. Control the size of the bidding documents: the bidding documents should be controlled within 30M. In order to avoid the slow upload speed when submitting the bidding documents and affecting the submission of the documents, please compress the size of the bidding documents and pictures as much as possible.",
            //二、控制投标文件大小：投标文件应控制在30M以内，为避免提交标书时上传速度慢，影响文件的递交，请尽量压缩投标文件和图片尺寸。
            titleContent3: "3. Bidding operation: It is recommended that suppliers avoid bidding during peak hours and upload technical bidding documents and business offer letters step by step (upload technical bidding documents first).",
            //三、投标操作：建议供应商避开高峰时间投标，可采用分步上传技术投标文件和商务报价函（先上传技术投标文件）的方法。
            titleContent4: "4. Specific demonstration:", //四、具体演示：
            operationProcess: "Supplier bidding operation process", //供应商投标操作流程
            clickOnTitleToView: "Click on the title to view", //点击标题查看

            table: {
                title: "Attachment list", //附件列表(英文)
                serialNumber: "No.", //序号
                fileTime: "Upload time", // 上传时间
                fileName: "Attachment Name", //附件名称
                fileSize: "Attachment size", //附件大小
                fileDesc: "Attachment description", //附件说明
                operation: "operation", //操作
                upload: "Download" //下载(英文)
            },
            dialog: {
                title: "Important information about supplier online bidding", //关于供应商在线投标的重要提示
                dialogTitle: "In order to ensure the smooth progress of the bidding activities, please read the following contents carefully:", //为保障招标活动的顺利进行，请投标供应商认真阅读以下内容：
                content1: "1. Avoid bidding peak hours", //一、避开投标高峰时间
                contentP1: "Peak hours (6:00 - 18:00 daily), especially the day before the bidding deadline.", //高峰时间（每日6:00—18:00），特别是投标截止日前一天。
                content2: "2. Control bidding file size", //二、控制投标文件大小
                contentP2: "Bidding documents should be controlled within 30M. In order to avoid slow uploading speed when submitting bids and affect the submission of documents, please compress the bidding documents as much as possible.", //投标文件应控制在30M以内，为避免提交标书时上传速度慢，影响文件的递交，请尽量压缩投标文件。
                content3: "3. Bidding operation", //三、投标操作
                contentP3: "It is recommended that suppliers avoid bidding during peak hours, and can use the method of uploading technical bidding documents and business quotation letters step by step (uploading technical bidding documents first). The specific demonstration of bidding operation is as follows:",
                //建议供应商避开高峰时间投标，可采用分步上传技术投标文件和商务报价函（先上传技术投标文件）的方法。投标操作具体演示如下：
                participateInBidd: "1. Participation in invitation to bid ", //1.参与招标
                participateInBiddCont1: "1) Log in to the Supplier Portal (ec.ccccltd.cn) using Internet Explorer", //使用IE浏览器登陆供应商门户网站（https://sp.iccec.cn）
                participateInBiddCont2: "2) After logging in, click Invite Announcement. After clicking an announcement to enter, there is a participation button at the bottom of the webpage, click to enter to fill in the contact information and submit. At this time, the system will prompt you that you have 'successfully registered'.",
                //登陆后点击邀请公告。点击一条公告进入后，网页下方有一个参与按钮，点击进入填写联系信息并提交。此时系统会提示您已“报名成功”。
                biddingDocuments: "2. Download the bid inviting file ", //下载招标文件
                biddingDocumentsCont1: "1) The bid inviting party receive the bid fee and will send the bid inviting party file to the supplier through the system. You can see the download of the purchase file in the to-do reminder. ",
                //招标人收到标书费用，会通过系统给供应商发送招标文件，您在待办提醒里可以看到采购文件下载
                biddingDocumentsCont2: "2)To-do alerts can also provide questions, bids, add-ons, clarifications and other information.",
                //待办提醒还可以提供答疑、投标、补遗、澄清等信息。
                tender: "3.tender", //投标
                tenderCont1: "1) Please check the to-do reminder after the bidding phase starts, click.", //投标阶段开始后请查看待办提醒，点击。
                tenderCont2: "2) Suppliers can also click on the business collaboration below the address bar of the supplier portal to enter your work interface. ",
                //供应商也可以点击供应商门户地址栏下方的业务协同，进入您的工作界面。
                tenderCont3: "3) After entering the work interface, there is the plan you participated in on the left side of the page. Click the plan and enter the bidding menu to bid. ",
                //进入工作界面后，页面左侧有您参与的方案，点击方案后进入投标菜单进行投标。
                tenderCont4: "4) In order to avoid bidding failure caused by large attachments, it is recommended to complete online bidding one day before the end of bidding. ",
                //为避免附件大造成投标失败，建议在投标结束前一天完成网上投标。
                tenderCont5: "You can also upload the bidding documents step by step, first fill in the quotation form, upload the technical bidding documents, and click the submit button; at this time, the system prompts",
                //您也可以分步上传标书文件，首先填写报价表，并上传技术投标文件，点击提交按钮；此时系统提示
                aTender: "Successful bid", //投标成功
                tenderCont6: "After the business quotation form is completed, click the ", //在商务报价表做好后，在投标菜单点击
                tenderCont7: " button, modify the quotation, upload the business quotation file to the system through the 'Upload' button, click Submit to complete the final quotation.",
                //按钮，修改报价，通过“上传”按钮把商务报价文件上传至系统后，点击提交完成最终报价。
                tenderCont8: "Notes: Please do not click Cancel bidding, after clicking, the system will delete all bidding files.",
                //备注：请不要点击撤销投标，点击后系统会删除所有投标文件。
                reportAgain: "Report again", //再次上报
                toClarify: "4.clarification", //澄清
                toClarifyCont: "During the bid evaluation stage, the invited tenders will release clarification documents through the system, please check and reply in the to-do reminder.",
                //在评标阶段，招标方会通过系统发布澄清文件，请在待办提醒中查看并回复。
                question: "5. Question ", //质疑
                questionCont: "If suppliers have questions about the bid inviting file, they can click on the business collaboration on the home page, find the participating projects on the left side of the business collaboration page, click on the participating projects to find the question and answer menu, upload your question file, and also Check the answers from bid inviting party.",
                //供应商如对招标文件有疑问，可通过点击首页的业务协同，在业务协同页面左侧找到参与的项目，点击参与的项目找到质疑答疑菜单，上传您的质疑文件，也可查看招标方答疑文件。
                addendumFile: "6. Check the addendum file", //查看补遗文件
                addendumFileCont: "If the bid inviting party posts an addendum, you can check it out in the To-Do Alerts on the homepage.", //如果招标方发布补遗文件，您可以在首页的待办提醒里查看。
                notes: "4. Electronic tender size notes", //四、电子标书大小注意事项
                notesCont1: "In the process of making bidding files, because the bidding book contains many pictures, the file is very large and the upload is affected. In order to avoid slow uploading speed when submitting bids, please try to compress the size of bidding files and pictures, and the file size should be controlled within 30M. You can also convert Word files to PDF format and use compressed packet software to compress the file size.",
                //在制作投标文件的过程中，因投标书含有许多图片导致文件很大而影响上传。为避免提交标书时上传速度慢，请尽量压缩投标文件和图片尺寸，文件大小应控制在30M以内。也可以将Word文件转换为PDF格式并使用压缩包软件，压缩文件大小。
                notesCont2: "1. There are 2 ways to convert to PDF format:", //转换为PDF格式有2种方法：
                notesCont3: "1) One is to save directly in Word as PDF format and compress the size (including office 2007, 2010 and 2013 versions).", //一种是在Word中直接另存为PDF格式，并压缩尺寸（含office2007, 2010和2013版本）
                notesCont4: "2) One is to install a PDF virtual printer to automatically generate PDF documents. (office 2003 does not carry PDF conversion, you need to install this software, PDF Creator software is open source software, anyone can install and use it for free). Download address",
                //一种是安装PDF虚拟打印机，自动生成PDF文档。（office2003不带PDF转换，就需要安装此软件，PDFCreator软件为开源软件，任何人都可以免费安装使用）。下载地址
                click: " (click) ", //(点击)
                notesCont5: "2. The following is how to save office 2007 and above directly to PDF format:", //以下为office 2007及以上版本直接另存为PDF格式的方法：
                notesCont6: "1) Take office 2010 as an example, select Save File As in the Word document, and select PDF for the save type.", //以office2010为例，在Word文档中选择文件另存为，保存类型选择
                notesCont7: "2) Under Optimization, select 'Optimize for the following formats", //在优化项选择“针对以下格式优化
                notesCont8: "files can be compressed to less than 20M.", //可将文件压缩至20M以内。
                smallestFileSize: "minimum file size'", //最小文件大小
                sure: "Confirm", //确定
                cancel: "Cancel", //取消
                spread: "Expand", //展开
                shrinkage: "shrink" //收缩
            }
        },
        login: {
            title: "Supplier Login", //供应商登录
            pwLogin: "Password login", //密码登录
            smsLogin: "SMS login", //短信登录
            pleaseUn: "User name/mobile phone number", //用户名/手机号
            pleasePw: "Please enter password", //请输入密码
            loginName: "Log in", //登录
            smsSendSuccessTip1: "SMS verification code has been sent to", //短信验证码已发送至
            smsSendSuccessTip2: "Please note that check", //请注意查收
            telNo: "Mobile phone number", //手机号
            smsVerCode: "SMS verification code", //短信验证码
            sendVerCode: "Send verification code", //发送验证码
            sended: "Has been sent", //已发送
            jjt: "AC", //交建通
            wx: "wechat", //微信
            Copyright: "Copyright © 2018 CCCC All rights reserved.", //Copyright © 2018 中国交建 All rights reserved.
            statement: "Final interpretation: Min ICP No. 2022005227-2 China Communications Construction", //最终解释权：闽ICP备2022005227号-2 中国交建
            acApiErrorObj: {
                error1: "This account has been locked for 30 minutes due to invalid login for more than 6 times", //该登录账号因无效登录超过6次已被锁定30分钟
                error2: "unnamed", //未实名
                error3: "The login account has been frozen", //登录账号已被冻结
                error4: "The system service is unavailable. Please try again later" //系统服务暂不可用，请稍后重试
            },
            pwApiErrorObj: {
                error1: "Login account and login password do not match, please re-enter", //登录账号与登录密码不匹配，请重新输入
                error2: "Please swipe to complete verification" //请滑动完成验证
            },
            telErrorObj: {
                error1: "Please enter the correct phone number", //请输入正确的手机号
                error2: "The mobile phone number does not match the SMS password, please re-enter.", //手机号与短信密码不匹配，请重新输入。
                error3: "Invalid SMS verification code If you log in for six times, your phone number will be locked for 30 minutes", //手机号短信验证码无效登录6次，将锁定手机号30分钟
                error4: "The system service is unavailable. Please try again later" //系统服务暂不可用,请稍后重试
            },
            smsSliderErrorObj: {
                error1: "Please swipe to complete verification" //请滑动完成验证
            },
            smsErrorObj: {
                error1: "Do not repeat the transmission, the verification code can be obtained again after the countdown is completed", //请勿重复发送，倒计时完成后可再次获取验证码
                error2: "Failed to send the verification code, please try again later" //发送验证码失败,请稍后再试
            },
            upLang: {
                _startTEXT: "Hold down the slider and drag it to the far right", //请按住滑块，拖动到最右侧
                _yesTEXT: "Pass the verification", //验证通过
                _noTEXT: "Verification fail", //验证不通过
                _error300: "Oops, there's an error. Click <a href='javascript:__nc.reset()'> to refresh </a> again.", //哎呀，出错了，点击<a href="javascript:__nc.reset()">刷新</a>再来一次(英文)
                _errorNetwork: 'If the network is not strong, please <a href="javascript:__nc.reset()"> click to refresh </a>' //网络不给力，请<a href="javascript:__nc.reset()">点击刷新</a>
            }
        },
        retrievePassword: {
            contactsMobile: "Mobile Number：",
            contactsMobileMsg: "Please enter the country code - mobile number",
            authCode: "Verfication Code：",
            authCodeMsg: "Please enter the SMS verification code",
            contactsEmail: "Email：",
            contactsEmailMsg: "Please enter E-mail",
            getCode: "Get verification code",
            retrievePassword: "Retrieve password", //取回密码

            changePassword: "Change password", // 修改密码
            oldPassword: "Old password：", // 旧密码
            pleaseOldPassword: "Please enter your old password", // 请输入旧密码
            newPassword: "New password：", // 新密码
            pleaseNewPassword: "Please enter your new password", // 请输入新密码
            verifyNewPassword: "Please enter the correct password", // 请输入正确的密码
            confirmPassword: "Confirm password：", // 确认密码
            pleaseConfirmPassword: "Please confirm the password", // 请确认密码
            pleasePw: "Please enter password", //请输入密码
            contactUs: "Contact us", // 联系我们
            title: "Retrieve user name and password online", //在线取回用户名密码
            content1: "First download and write", //首先下载并填写
            content2: "《Supplier Username and Password Recovery Application Form》", //《供应商用户名及密码找回申请表》
            downLoad: "Click to download", //点击下载
            content3: "，Need to stamp the official seal of the unit and scan, and then invite me to scan the pieces and the salesperson to upload the damaged pieces to the system. Submit a user and password retrieval application. After the application is approved by the administrator, the system automatically sends the user name and random password to the email address filled in during the application, and then reset the random password by logging in to the system according to the email information.", //，需加盖单位公章并扫描，然后招申请我扫后件和营业员面扫损件上传到系统。提交用户及密码找回申请，申请由管理员审批通过后，系统自动把申请找回额用户名及随机密码发送到申请时填写的邮箱，根据邮件信息登录系统重置随机密码。
            content4: "（Note: you can enter the new mobile phone number and contact information to retrieve） After submitting the application, it will be processed on the working day, and the result will be sent to the recipient email address, which will be postponed in case of holidays.", // （注：可以输入新的手机号和联系人信息进行取回）
            supName: "Supplier name：", // 供应商名称
            holderSupName: "Please enter the supplier name", // 请输入供应商名称
            hintContent1: "Supplier username, Password Retrieve applicant and contact information：", // 供应商用户名，密码取回联系人及联系方式：
            hintContent2: "（Note: The applicant information must be consistent with the applicant information in the application form, and the applicant may not be a registered contact.）", // （注：申请人信息须与申请表中申请人信息一致，该申请人不一定是注册联系人。）
            contactName: "Applicant name:", // 申请人姓名
            contactPerson: "Contact：", // 联系人
            mobilePhone: "Mobile phone number", // 手机号
            Authentication: "Authentication：",
            holderContactPerson: "Please enter the contact name", // 请输入联系人姓名
            holderMobilePhone: "Please enter the contact phone", // 请输入联系人手机
            holderContactName: "Please enter the applicant's name",
            contactMobile: "Applicant phone number:", // 申请人手机：
            holderContactMobile: "Please enter the applicant's mobile phone", // 请输入申请人手机
            effectiveMobile: "Please enter a valid mobile number", // 请输入有效的手机号码
            hintContent3: "Valid email addresses that accept user names and passwords:", // 接收用户名及密码的真实有效邮箱
            hintContent4: "（Note: Please fill in a valid email address. After the application is approved, the user name and random password will be sent to the email address. This email address is not necessarily the registered contact email address.）", //（注：请填写真实有效的邮箱，申请信息审批通过后，会把用户名及随机密码发送至该邮箱。该邮箱不一定是注册联系人邮箱。）
            hintContent5: "The contact information must be consistent with the scanned copy", //联系人信息必须与扫描件保持一致
            hintContent6: "A combination of 8-16 uppercase and lowercase letters, special characters, and numbers", //6-8位大小写字母，特殊字符和数字的组合
            hintContent7: "6 to 8 characters in length", // 长度在6到8个字符
            email: "E-mail", //E-mail地址：
            verificationCode: "Verification code：", // 验证码
            holderEmail: "Please enter your E-mail address", //请输入E-mail地址
            effectiveEmail: "Please enter the correct email address", //请输入正确的邮箱地址
            holderVerificationCode: "Please enter the verification code", // 请输入验证码
            effectiveVerificationCode: "Please enter the correct verification code", // 请输入正确的验证码
            fileinfoTypeName: "Name", // 名称
            fileinfoType1: "Scanned copy of supplier username and password retrieval request form", //供应商用户名及密码找回申请表扫描件
            fileinfoType2: "Scanned copy of supplier's business license", //供应商营业执照扫描件
            fileType: "Type", //类型
            fileTypeName: "Picture", //图片
            fileName: "Files", //文件
            operation: "Operation", //操作
            upload: "Upload", //上传
            delete: "Delete", //删除
            downloadSampleTable: "Sample download", //样表下载
            submit: "Submit", //提交
            reset: "reset", //重置
            confirmTitle1: "Your vendor password retrieval application has been successfully submitted, please check your email or SMS", // 您的供应商密码取回申请提交成功，请注意查收邮件或短信
            confirmHint: "Tip", //提示
            ascertain: "Confirm", //确定
            confirmTitle2: "Please upload the attachment and submit the application!", //请您上传附件后提交申请！
            fileSuccess: "Attachment uploaded successfully", //附件上传成功
            uploadError: "Upload error, please contact administrator", //上传出错，请联系管理员
            confirmTitle3: "Incorrect supplier name! Please enter. The field cannot be empty or blank", //供应商名称的输入有误！请输入，该项不能为空或空格
            confirmTitle4: "Supplier name does not exist, please enter the correct supplier name!", //供应商名称不存在，请输入正确的供应商名称！
            confirmTitle5: "Please complete the information and upload the attachment!", // 请完善信息后上传附件！
            fileSizeNO50: "The file size cannot exceed 50M!", //文件大小不可超过50M！
            confirmTitle6: "The password is changed successfully. Please log in again!", // 密码修改成功，请您重新登录
            confirmTitle7: "Recall successful!", // 撤回成功
            confirmTitle8: "The application has not been completed yet. Please click the complete information button to complete the application!", // 申请尚未完成，请点击完善信息按钮完成申请！
            confirmTitle9: "Your registration application is returned, you can click the button to check the reason for the return or modify the registration information", //您注册申请审批退回 ，可点击按钮查看退回原因或修改注册信息
            uploadBmpError: "Upload file format error!", //上传文件格式错误！
            NoSameName: "Please do not upload files with the same name"
        },
        supReg: {
            title: "register",
            stepName: [
                "Registration Instructions",
                "Notice of Registration",
                "Business Ethics Agreement",
                "Apply For a Username",
                "Supplier Basic Information\n" + "\n",
                // "Contact information",
                "Legal Person Information",
                "Product Information",
                "Bank Information",
                "Historical Cooperation Achievements",
                "Qualification Documents"
            ],
            contentTitle: [
                "1. Read the registration notice.",
                "2. Read the 《Agreement of Business Ethics and Principles》and agree to the agreement.",
                "3. Apply for a username.",
                "4. Fill in the details and upload the qualification documents(* Required Fields).",
                "5. Submit to the relevant company and waiting for approval."
            ],
            contentP: [
                "",
                'Check "Have read and agree to the Agreement on Compliance with Business Ethics"',
                "Apply for a user name as required, fill in the contact details, and select the recommended unit",
                "Fill in supplier details carefully and upload relevant qualification documents for inquiry",
                'After confirming that the information is correct, click the "Submit" button'
            ]
        },
        supNotice: {
            contentTitle: "Notice of Registration ",
            contentP: [
                '1. Materials Purchasing Management Information System of CCCC (http://ec.ccccltd.cn) is the only legitimate website for trade suppliers and CCCC. CCCC keeps a positive cooperation relationship with suppliers on the basis of "Heart-to-heart business, win-win cooperation".',
                "2. There is no other cost to be beared by suppliers for this registration, and CCCC will not charge to suppliers by means of annual verification, membership, performance assessment, etc. Suppliers must ensure all the registration information shall be real, accurate and updated.",
                "3.In case of system upgrade, the platform operator has the right to extend the end time of bidding and the end time of sale."
            ]
        },
        moralAgree: {
            contentH: "AGREEMENT of BUSINESS CONDUCT AND ETHICS",
            errMsg: [
                "Please check have read and agree to abide by the Business Ethics Agreement."
            ],
            contentCheckbox: ["I have read the Terms & Conditions and accept them"]
        },
        applyUsername: {
            contentTitle: {
                loginInfo: "User information(* Required Fields)",
                contacts: "Contact information(* Required Fields)",
                reCompany: "Recommended By(* Required Fields)"
            },
            contentTitles: {
                contactsWay: "Telephone, mobile number and email address are important contact ways, please provide accurate information for us to follow-up.",
                reCompanyMsg: "The recommendation company is responsible for approving the supplier registration. Please choose carefully"
            },
            contentLabel: {
                supName: "Supplier Name:",
                id: "username:",
                authCode: "Verfication Code",
                pwd: "Password:",
                repwd: "Confirmed Password:",
                contacts: "Contacts:",
                contactsTel: "Telephone:",
                contactsFax: "Fax:",
                contactsMobile: "Mobile Number:",
                contactsInfo: "Contact information",
                contactsEmail: "Email:",
                provinces: "Province, City/Town, District:",
                reCompany: "Recommended By:",
                mobile: "Mobile Number:",
                ID: "Contact ID number/overseas social security number:",
                username: "Username"
            },
            inputPlc: {
                supNameMSg: "Please enter the supplier name",
                idMsg: "Please enter your username",
                authCodeMsg: "Please enter the SMS verification code",
                pwdMsg: "8 characters or longer. Include 1 number at least",
                repwdMsg: "Please enter your password again",
                contactsMsg: "Please enter the name",
                contactsTelMsg: "Please enter the country code - mobile number",
                contactsFaxMsg: "Please enter the area code - fax number",
                contactsMobileMsg: "Please enter the country code - mobile number",
                contactsEmailMsg: "Please enter E-mail",
                IDMsg: "Please enter the contact ID number/foreign social security number",
                provincesMsg: "",
                reCompanyMsg: "Please select the recommended unit"
            },
            inputRules: {
                pwdMsg1: "",
                pwdMsg2: "The password must contain uppercase and lowercase letters, numbers, and special characters",
                repwdMsg: "Your confirmed password and new password do not match.",
                contactsMsg: "Name",
                contactsTelMsg: "Please enter the country code - mobile number.",
                contactsFaxMsg: "",
                contactsMobileMsg: "Please enter the country code - mobile number",
                contactsEmailMsg: "The email format is incorrect",
                provincesMsg: "Please select a province or region",
                sliderMsg: "Please enter your mobile phone number first",
                reCompanyMsg: "The recommended unit cannot be empty",
                reCompanyMsg1: "The recommended unit does not exist",
                reCompanyMsg2: "Please enter non-group headquarters",
                supNameMSg: "The supplier name cannot be empty",
                supNameMSg1: "The vendor name already exists",
                codemsg: "The code cannot be empty",
                mobilemsg: "The mobile phone number cannot be empty",
                mobilemsg1: "The mobile number already exists"
            },
            btn: {
                getCode: "Get verification code",
                msg1: "Hold down the slider and drag it to the far right",
                msg2: "Pass the verification",
                msg3: "Loading...",
                msg4: "Verification fail",
                msg5: "哎呀出错了，点击",
                msg6: "刷新",
                msg7: "再来一次（英文）",
                msg8: "网络不给力，请",
                msg9: "点击刷新（英文）",
                msg10: "I have registered to check the approval progress"
            },
            dialogMsg: {
                msg1: "The recommended unit you have selected is",
                msg2: ",The recommending unit is responsible for reviewing your company's registration information. Please check carefully to avoid mistakes!",
                title: "tips"
            }
        },
        supInfo: {
            contentTitle: {
                basicInfo: "Basic information (* Required Fields)",
                producer: "Manufacturer(fill in)",
                dealer: "Distributor(fill in)"
            },
            contentLabel: {
                supName: "Supplier Name:",
                abbreviation: "Abbreviation:",
                supType: "Supplier Type:",
                hisName: "Historical name:",
                isForeign: "Whether it is a foreign trade supplier",
                isInside: "CCCC Internal Enterprise:",
                isThree: "Whether the three syndromes are in one",
                Authentication: 'Authentication:',
                unifyCode: "Unify the social credit code",
                GATunifyCode: "Unify the social credit code",
                framework: "",
                organization: "",
                dutyParagraph: "Tax Identification Number (TIN):",
                domicile: "Registered Address:",
                businessAddress: "Office Location:",
                postcode: "Postcode:",

                registeredCapital: "Registered/Authorised Capital:",
                currency: "Currency:",
                capital: "Paicl-up capital:",
                UniProperty: "Unit property:",
                companyType: "Type of company:",
                businessScope: "Scope of Business:",
                foundingTime: "Date of Establishment:",
                businessTerm: "Operation Period: ",
                organizationChart: "Organizational structure and marketing network:",
                companyName: "The name of the group company:",
                companyProfile: "Company Profile:",
                capacity: "capacity:",
                processStatus: "Technological status:",
                manufacturer: "Name of the manufacturer of the product being sold:",
                qualification: "Sales agent qualification:",
                userInfo: "User information",
                country: "Country of Registration:",
                business: "Certificate of Incorporation Number/Business License Number: ",
                organiza: "Branches and Contact Information:",
                unitCategory: "Company Category:",
                abroadSocialSecurity: "Social security number/Identification"
            },
            inputPlc: {
                supName: "please enter Supplier name",
                abbreviation: "Please enter abbreviation",
                unitCategory: "Please enter the company category",
                hisName: "Please enter a history name",
                choose: "Please select",
                yes: "yes",
                no: "no",
                mobilePhone: 'mobile phone',
                email: 'email',
                unifyCode: "Please enter a unified Social credit code",
                GATunifyCode: "Please enter a unified Social credit code",
                framework: "",
                chooseDate: "Select date",
                dutyParagraph: "Please enter your tax ID",
                domicile: "Please enter address",
                businessAddress: "Please enter the office address",
                UniProperty: "Please select the unit nature",
                postncode: "please enter postcode",
                registeredCapital: "Please enter registered capital",
                capital: "Please enter paid-in capital",
                input: "please enter",
                country: "Please select country",
                business: "Please enter business license number",
                organiza: "Please enter the branch office and contact information",
                personal: "individual",
                company: "unit",
                abroadSocialSecurity: "Please enter your social security number/Identification"
            },
            inputRules: {
                supType: "Please select a vendor type",
                choose: "Please choose yes or no",
                chooseDate: "Please fill in the date",
                chooseCurrency: "Currency information cannot be empty",
                conpanyType: "please choose company type",
                businessScope: "Please enter the scope of business",
                foundingTime: "Please select the establishment time",
                businessTerm: "please choose Operation period",
                max: "max no six",
                postcode: "postcode is err",
                organizationChart: "Please enter organizational structure and marketing network",
                companyProfile: "Please enter company profile",
                country: "Please select country",
                unitCategoryType: "Please select a unit or individual",
                abroadSocialSecurity: "Please enter your social security number/Identification"
            }
        },
        contactInfo: {
            contentTitle: { contactsInfo: "Contact information(* Required Fields)" },
            contentLabel: {
                legalName: "Name of Legal Person:",
                controlAgent: "Actual controlling agent",
                xuhao: "No.",
                controlType: "Real control type",
                controlId: "Control subject code or certificate number",
                legalMobile: "Legal representative mobile phone",
                legalID: "Owner/Authorized Person identification",
                saleID: "Sales person ID number/overseas social security number",
                legalTel: "Legal representative landline telephone:",
                legalFax: "Facsimile of legal representative:",
                legalEmail: "Legal representative email address:",
                market: "Sales person in charge:",
                marketMobile: "Mobile Number:",
                marketTel: "Telephone:",
                marketFax: "Fax:",
                marketEmail: "Email:",
                web: "Company Website:",
                DJG: "Chief executive officer",
                DJGT: "Types of directors and supervisors",
                DJGN: "Names of directors, supervisors and officials",
                DJGID: "Certificate number of directors and supervisors"
            },
            inputPlc: {
                legalNameMsg: "Please enter the legal representative name",
                saleID: "Please enter the sales person ID number/overseas social security number",
                legalMobileMsg: "Please enter the mobile phone number of the legal representative",
                contactsMobileMsg: "Please enter the country code - mobile number",
                legalTelMsg: 'Please enter the legal representative area code and landline telephone number, for example, "010-********".',
                legalID: "Please enter the legal representative ID number/overseas social security number",
                legalFaxMsg: 'Please enter the legal representative area code and fax number, e.g. "010-********"',
                legalEmailMsg: "Please enter the legal representative email address",
                marketMsg: "Please enter the name of the sales manager",
                marketMobileMsg: "Please enter the mobile phone number of the sales director",
                marketTelMsg: 'Please enter the area code and landline phone number of the sales officer, e.g. "010-********"',
                marketFaxMsg: 'Please enter the sales officer area code and fax number, e.g. "010-********"',
                marketEmailMsg: "Please enter the email address of the sales manager",
                webMsg: "Please enter the website address"
            },
            inputRules: {
                mobileMsg: "The format of the mobile phone number is incorrect",
                legalTelMsg: "The fixed-line telephone format of the legal representative is incorrect (format: area code + number, such as 010-1234567)",
                legalFaxMsg: "The fax format of the legal representative is incorrect (format: area code + number, such as 010-1234567)",
                marketTelMsg: "Incorrect format of sales person's landline (format: area code + number, such as 010-1234567)",
                marketFaxMsg: "Incorrect fax format (format: area code + number, such as 010-1234567)",
                emailMsg: "The email format is incorrect"
            }
        },
        productInfo: {
            contentTitle: { productInfo: "Product information" },
            tableTh: {
                productCode: "Product code no",
                productName: "Product name",
                productTrademark: "Product trademark",
                remark: "Remarks",
                operation: "Operation"
            },
            btn: {
                add: "Add",
                newAdd: "Add",
                batchDel: "batch delete",
                del: "Delete",
                cancel: "Cancel",
                confirm: "Confirm"
            },
            dialog: {
                info: "tips",
                title: "Equipment and materials selection",
                inp: "please enter",
                nextMsg: "Please select at least one product information"
            },
            delInfo: {
                batchDelInfo: "Please select at least one product to deleted",
                delInfo: "This action will permanently delete this row, do you want to continue?",
                confirmDel: "Successfully deleted",
                cancelInfo: "undeleted"
            }
        },
        financeInfo: {
            contentTitle: { financeInfo: "Bank Information(* Required Fields)" },
            contentLabel: {
                bankAccount: "Bank Account Number:",
                depositBank: "Name of Bank:",
                bankAccountName: "Bank Account Name:",
                bankAddress: "Address of Bank:",
                beneficiary: "beneficiary's address:",
                swiftCode: "Swift code:",
                isWhether: "Whether to accept payment by L / C ?\n" + "( Letter of Credit):"
            },
            inputPlc: {
                bankAccountMsg: "Please enter your bank account number",
                depositBankMsg: "Please enter your bank",
                bankAccountNameMsg: "Please enter your bank account name",
                bankAddressMsg: "Please enter the bank address",
                beneficiaryMsg: "Please enter the recipient's address",
                swiftCodeMsg: "Please enter bank international code",
                isWhetherMsg: "Please choose yes or no"
            }
        },
        hisCooperation: {
            contentTitle: { hisCooperation: "Historical cooperation achievements" },
            contentLabel: {
                cooperationCompany: "Cooperative enterprise:",
                cooperationPerformance: "Achievements of cooperation with CCCC:",
                peerCooperation: "Cooperation performance with enterprises in the same industry:",
                remark: "remark:"
            },
            inputPlc: {
                input: "please enter",
                cooperationCompanyMsg: "Please enter a partner company"
            }
        },
        qualificationFile: {
            contentTitle: {
                qualificationFile: "Company Qualification Documents(* Required Fields)"
            },
            contentTitles: {
                hintMsg1: "Tip: Please Upload The Original Scanned Copy, The Image File Should Be Less Than ",
                hintMsg2: "15 ",
                hintMsg3: "M,and Other Files Should Be Less Than ",
                hintMsg4: "30 M"
            },
            tableTh: {
                name: "Attachment Name",
                type: "Type",
                file: "Filename",
                enclosureNotation: "Attachment Description",
                operation: "Operation",
                input: "Please Enter",
                size: "附件大小（英文）"
            },
            tableTd: {
                businessLicense: "Certificate of Incorporation/Business License Copy",
                identityCard: "Owner/Authorized Person Identification",
                frameworkImg: "Organization Code Certificate Picture",
                taxationImg: "Tax Registration Certificate",
                taxationImg2: "（Including VAT General Taxpayer Red Seal Page）",
                qualityControl: "Quality Management System Documentation",
                specialIndustry: "Special Certificate",
                organizationChart: "Organizational Structure and Marketing Network Related Documents",
                companyQualification: "Certificate of Award",
                productionLicence: "Production Certificate",
                distributiontImg: "Distribution Agent Qualification Certificate",
                financialStatement: "Financial Statements (Audited Financial Statements For The Previous Year)",
                cooperationFile: "Customs Declaration Registration (Customs Registration Code)",
                businessLicenses: "Business Certificate",
                environmentalManagement: "Environment Management System Documentation",
                healthySafety: "Health Management System Documentation ",
                otherFiles: "Other Professional Certifications",
                img: "Picture",
                file: "File"
            },
            btn: { uploading: "Upload", del: "Delete" },
            info: {
                uploadErr1: "Supported format of uploaded images:.jpg.png.jpeg.gif.webp Each does not exceed 15M",
                uploadErr2: "Upload image size cannot exceed 15M!",
                uploadErr3: "Support format for upload files:.xls.xlsx.doc.docx.pdf each not exceeding 15M",
                uploadErr4: "Upload file size cannot exceed 30M!",
                delErr: "Please upload the file first",
                subErr1: "The picture of the business license copy cannot be empty",
                subErr2: "The organization code certificate picture cannot be empty",
                subErr3: "The tax registration certificate picture cannot be empty",
                dialog1: "Please confirm that the information is valid. Are you sure to submit it?",
                dialog2: "You have successfully submitted the registration application information. Please be patient and wait for the audit。",
                sameFile: "Please do not upload files with the same name!",
                upload1: "File uploaded successfully"
            },
            file: {
                download: "download",
                clickdownload: "Click to download",
                tip: "(including the red seal page of value-added tax general taxpayers)"
            }
        },
        mobileValidate: {
            title1: { name: "Username", psd: "Password" },
            inputPlc: {
                mobile: "Please enter the country code - mobile number",
                name: "Please enter your username",
                psd: "Please enter password"
            },
            inputRules: {
                mobile: "Please enter the correct phone number",
                code: "Please enter a six-digit verification code"
            },
            title: {
                title: "Use the account password to complete identity authentication and check the registration approval progress"
            },
            btn: { code: "Send verification code", sub: "Submit for certification" },
            msg: {
                q: "Can't receive SMS verification code？",
                a: "Please check the mobile phone network and verify whether the mobile phone blocks system SMS. If it is normal, please obtain it again or try again later.",
                msg1: "当前手机号未注册供应商（英文）"
            }
        },
        foreignSupRegDetail: {
            btn: {
                perfect1: "Improve the profile information",
                recall: "Withdraw an application",
                perfect2: "Modify information"
            },
            msg: {
                msg1: "The registration information of your company has been approved by",
                msg2: ", and the supplier is not allowed to withdraw the registration application",
                msg3: "The registration information of your company has not been approved, are you sure to withdraw the registration application",
                msg4: "Successful withdrawal of application",
                msg5: "The withdrawal application has been cancelled"
            }
        },
        approval: {
            title: {
                title: "Approval record",
                title1: "Instructions",
                title2: "conclusion",
                title3: "Opinion"
            },
            msg: { msg1: "审批中（英文）", msg2: "暂无数据（英文）" }
        }
    }
};